<template>
  <div class="enter-warehouse-register">
    <div class="enter-warehouse-register-search">
      <div class="screen">
        <el-select class="white w200" clearable filterable v-model="screen.projectId" placeholder="请选择项目">
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input class="white w240" v-model="screen.inboundOrderNo" placeholder="请输入单号"></el-input>
        <el-date-picker
          class="w240"
          v-model="screen.inboundDate"
          type="daterange"
          placeholder="请选择日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-button class="btn-blue" @click="onScreen">搜索</el-button>
      </div>
      <div class="operation-btn">
        <el-button class="btn-white" @click="openExcel('add')"
          >增值服务导入</el-button
        >
        <el-button class="btn-white" @click="openExcel('subject')"
          >科目明细导入</el-button
        >
      </div>
    </div>

    <DropTable
      ref="table"
      :columns="tableTitleList"
      :data="tableData"
      tableKey="enterWarehouseRegisterList"
      border
    >
      <template slot="sort" slot-scope="scope">{{ scope.$index + 1 }}</template>
      <template slot="action" slot-scope="scope">
        <el-button
          class="btn-text"
          type="text"
          @click="enterWarehouseRegister(scope.row.id)"
        >登记</el-button>
      </template>
    </DropTable>

    <div class="footer">
      <pagination-tpl
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        :layout="layout"
        @queryChange="queryChange"
        @onSizeChange="onSizeChange"
      ></pagination-tpl>
    </div>

    <!-- 导入 -->
    <el-dialog :title="type ==='add'?'增值服务费用导入':'科目明细导入'" top="18vh" :visible.sync="promptingDialog" width="420px" :before-close="closeOrderDown">
      <div class="border"></div>
      <div>
        <div>
          <i class="el-icon-warning"></i>
          <span class="sub-title introduce">功能介绍</span>
        </div>
        <p class="tips">{{type ==='add'?'批量导入进仓单增值服务费用':'批量导入进仓单明细费用'}}</p>
      </div>
      <div class="down-tmp">
        <div class="sub-title">
          <span>下载导入模板</span>
          <span class="sub-tips">(点击下载)</span>
        </div>
        <el-button type="text" class="btn-text" @click="downTmp">{{type ==='add'?'增值服务导入模板.xlsx':'科目明细导入模板.xlsx'}}</el-button>
      </div>
      
      <el-form
        class="enter-warehouse-project-form"
        :rules="enterWarehouseProjectFormRules"
        ref="enterWarehouseProjectForm"
        :model="enterWarehouseProjectForm"
      >
        <el-form-item label="项目名称" prop="projectId">
          <el-select class="white" clearable v-model="enterWarehouseProjectForm.projectId" placeholder="请选择项目">
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="币制" prop="currency">
          <el-select class="white"
            v-model="enterWarehouseProjectForm.currency" placeholder="请选择币制">
            <el-option v-for="item in currencySystemList" :key="item.id" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否代收代付" prop="agentBusiness">
          <el-radio-group v-model="enterWarehouseProjectForm.agentBusiness">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div>
        <p class="sub-title">{{type ==='add'?'增值服务导入':'明细导入'}}</p>
        <el-upload
          v-if="isUpload"
          v-loading.fullscreen.lock="loading3"
          element-loading-text="文件上传中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          class="upload"
          ref="upload"
          action="#"
          :show-file-list="false"
          :auto-upload="true"
          :before-upload="uploadExcel"
        >
          <el-button slot="trigger" type="text" class="btn-text"
            >{{uploadTipsName}}</el-button
          >
        </el-upload>
        <div v-else class="upload-tips-container">
          <div class="upload-tips-name">
            {{uploadTipsName}}
            <i class="el-icon-error" @click="removeUploadOrder"></i>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeOrderDown"
          >取消</el-button
        >
        <el-button class="btn-blue" @click="confirmOrderDown('enterWarehouseProjectForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DropTable from "components/base/DropTable.vue";
import currencyMixins from "common/mixins/currency.js";
import PaginationTpl from "components/base/PaginationTpl";
import { downLoadFile, modifyNetTitle } from "common/js/util";
import EnterWarehouseRegister from "models/enter-warehouse-register";
import EnterExitWarehouseProjectMixins from 'common/mixins/enter-exit-warehouse-project'
export default {
  mixins: [currencyMixins, EnterExitWarehouseProjectMixins],
  data() {
    return {
      screen: {
        projectId: "",
        inboundOrderNo: "",
        inboundDate: ""
      },
      screenValue: {
        projectId: "",
        inboundOrderNo: "",
        inboundDate: ""
      },
      tableData: [], //项目列表
      tableTitleList: [
        { checked: true, label: '序号', prop: 'sort',
          fixed: "left", 
          slotName: "sort", // 自定义单元格插槽, 
        "width": '90'},
        { checked: true, label: '项目名称', prop: 'projectName'},
        { checked: true, label: '进仓单号', prop: 'inboundOrderNo' },
        { checked: true, label: '进仓日期', prop: 'inboundDate' },
        { 
          checked: true, 
          label: "操作", 
          prop: "action", 
          fixed: "right", 
          "width": "120",
          slotName: "action", // 自定义单元格插槽
        }
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      layout: 'jumper, prev, pager, next, sizes',
      loading3: false,
      enterWarehouseProjectForm: {
        projectId: "",
        currency: "",
        agentBusiness: 0
      },
      enterWarehouseProjectFormRules: {
        projectId: [
          { required: true, message: "请选择项目名称", trigger: "change" },
        ],
        currency: [
          { required: true, message: "请选择币制", trigger: "change" },
        ],
        agentBusiness: [
          { required: true, message: "请选择是否代收代付", trigger: "change" },
        ]
      },
      type: '',
      promptingDialog: false,
      uploadTipsName: '点击导入',
      /* 订单导入的流 */
      formData: null,
      /* 是否导入 */
      isUpload: true,
    };
  },
  components: {
    DropTable,
    PaginationTpl
  },
  created() {
    modifyNetTitle('进仓登记列表')
    this.getTableData();
    this.initEnterExitWarehouseProjectData();
  },
  methods: {
    //获取进仓列表
    getTableData() {
      let pageNo = this.currentPage;
      let pageSize = this.pageSize;
      let projectId = this.screenValue.projectId;
      let inboundOrderNo = this.screenValue.inboundOrderNo;
      let inboundBeginDate = this.screenValue.inboundDate?this.screenValue.inboundDate[0]:''
      let inboundEndDate = this.screenValue.inboundDate?this.screenValue.inboundDate[1]:''
      let data = {
        pageNo,
        pageSize,
        projectId,
        inboundOrderNo,
        inboundBeginDate,
        inboundEndDate
      }
      EnterWarehouseRegister.getEnterWarehouseRegisterList(data).then(res => {
        if (res.success) {
          let tableData = [];
          this.pageSize = res.result.size;
          this.total = res.result.total;
          res.result.records.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.projectName = value.projectName;
            obj.inboundOrderNo = value.inboundOrderNo;
            obj.inboundDate = value.inboundDate;
            tableData.push(obj);
          });
          this.tableData = tableData;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onScreen() {
      this.screenValue = this.screen;
      this.currentPage = 1;
      this.getTableData();
    },
    //查看登记详情
    enterWarehouseRegister(id) {
      let routeData = this.$router.resolve({
        path: '/service/enter-warehouse-register-index/enter-warehouse-register-details',
        query: {
          enterWarehouseRegisterId: id
        }
      });
      window.open(routeData.href, '_blank');
    },
    //翻页
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.getTableData();
    },
    onSizeChange(data) {
      this.pageSize = data.pageSize;
      this.getTableData();
    },
    downTmp() {
      if (this.type === 'add') {
        this.initEnterWarehouseAddServiceTmp()
      } else {
        let url = 'https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/oa/template/%E5%AF%BC%E5%85%A5%E8%BF%9B%E4%BB%93%E6%93%8D%E4%BD%9C%E8%B4%B9%E7%94%A8%E6%A8%A1%E6%9D%BF.xlsx'
        downLoadFile('科目明细导入模板',url)
      }
    },
    
    /** 
     * @desc 增值服务费用导入模板
    */
    initEnterWarehouseAddServiceTmp() {
      EnterWarehouseRegister.getEnterWarehouseAddServiceTmp().then(res => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      })
    },
    closeOrderDown() {
      this.removeUploadOrder()
      this.promptingDialog = false
    },
    confirmOrderDown(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isUpload) {
            return this.$message.error("请导入文件");
          }
          let formData = this.formData
          if (formData.get('projectId')) {
            formData.delete('projectId')
          }
          if (formData.get('currency')) {
            formData.delete('currency')
          }
          if (formData.get('agentBusiness')) {
            formData.delete('agentBusiness')
          }
          let agentBusiness = this.enterWarehouseProjectForm.agentBusiness?true:false
          formData.append("projectId", this.enterWarehouseProjectForm.projectId);
          formData.append("currency", this.enterWarehouseProjectForm.currency);
          formData.append("agentBusiness", agentBusiness);
          if (this.type === 'add') {
            EnterWarehouseRegister
              .postUploadAddServiceExcel(formData)
              .then(res => {
                if (res.success) {
                  this.$message.success("导入成功");
                  this.closeOrderDown()
                } else {
                  this.$confirm(res.message, "提示", {
                    showCancelButton: false,
                    confirmButtonText: "确定",
                    type: "warning"
                  }).then(() => {});
                }
              })
              .catch(res => {
                this.$message.error("导入失败");
              });
          } else {
            EnterWarehouseRegister
              .postUploadOperateFeeExcel(formData)
              .then(res => {
                if (res.success) {
                  this.$message.success("导入成功");
                  this.closeOrderDown()
                } else {
                  this.$confirm(res.message, "提示", {
                    showCancelButton: false,
                    confirmButtonText: "确定",
                    type: "warning"
                  }).then(() => {});
                }
              })
              .catch(res => {
                this.$message.error("导入失败");
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    removeUploadOrder() {
      this.formData = null
      this.uploadTipsName = '点击导入'
      this.isUpload = true
      this.enterWarehouseProjectForm.projectId = ""
      this.enterWarehouseProjectForm.currency = ""
      this.enterWarehouseProjectForm.agentBusiness = 0
    },
    //导入Excel表格
    uploadExcel(file) {
      var formData = new FormData();
      formData.append("file", file);
      this.formData = formData
      this.uploadTipsName = file.name
      this.isUpload = false
      return false;
    },
    openExcel(type) {
      this.type = type
      this.promptingDialog = true
    }
  }
};
</script>
<style lang="scss">
.enter-warehouse-register {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  .enter-warehouse-register-search {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .screen {
      display: flex;
      .w200 {
        width: 200px;
        margin-right: 16px;
      }
      .w240 {
        width: 240px;
        margin-right: 16px;
      }
    }
    .operation-btn {
      display: flex;
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 16px;
  }
  .el-icon-warning {
    font-size: 16px;
    color: #F47A25;
    margin-right: 6px;
    vertical-align: text-top;
  }
  .sub-title {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
  }
  .introduce {
    display: inline-block;
  }
  .tips {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    margin: 11px 0px 21px 0px;
  }
  .el-form {
    margin-bottom: 20px;
    .el-form-item {
      .el-form-item__label {
        line-height: 20px;
      }
      .el-form-item__content {
        width: 100%;
        .el-radio-group,
        .el-select {
          width: 100%;
        }
      }
    }
  }
  
  .el-radio-group {
    .el-radio__input.is-disabled .el-radio__inner {
      background-color: white;
      border-color: #DDE1E7;
    }

    .el-radio__input.is-disabled.is-checked:hover {
      border-color: #DDE1E7;
    }

    .el-radio__input.is-disabled.is-checked .el-radio__inner,
    .el-radio__inner:hover,
    .el-radio__input.is-checked .el-radio__inner {
      background-color: white;
      border-color: #2E68EA;
    }

    .el-radio__input.is-disabled.is-checked .el-radio__inner::after,
    .el-radio__inner::after {
      background-color: #2E68EA;
    }

    .el-radio__input.is-checked+.el-radio__label {
      color: #2E68EA;
    }
    .el-radio__label {
      display: inline-block;
      margin-top: 1px;
    }
  }
  .upload-tips-container {
    position: relative;
    width: 180px;
    .upload-tips-name {
      height: 30px;
      line-height: 30px;
      margin: 12px 0px;
      color: #2E68EA;
      background: #EBEEF5;
      border-radius: 2px;
      padding-left: 7px;
      box-sizing: border-box;
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      .el-icon-error {
        position: absolute;
        top: -5px;
        right: -8px;
        color: #999999;
        cursor: pointer;
      }
    }
  }
  .sub-tips {
    color: #999999;
  }
  .dialog-footer {
    margin-top: 16px;
    border-top: 1px solid #f7f7f7;
    padding-top: 16px;
    display: flex;
    justify-content: center;
    .btn-white {
      margin-right: 20px;
    }
  }
  
}
.el-message-box {
  max-height: 500px;
  overflow-y: auto;
}
.el-message-box__message p {
  word-wrap: break-word;
}
</style>
